@use './variables' as *;
@use '../../styles/abstracts/break-points' as *;

:host {
  display: $filter-groups-host-display;
}

.filter-groups {
  width: $filter-groups-width;
  padding-top: $filter-groups-padding-top;
  padding-right: $filter-groups-padding-right;
  padding-bottom: $filter-groups-padding-bottom;
  padding-left: $filter-groups-padding-left;
  margin-top: $filter-groups-margin-top;
  margin-right: $filter-groups-margin-right;
  margin-bottom: $filter-groups-margin-bottom;
  margin-left: $filter-groups-margin-left;
}

.header-text {
  font-family: $filter-groups-header-font-family;
  font-size: $filter-groups-header-font-size;
  font-weight: $filter-groups-header-font-weight;
  line-height: $filter-groups-header-line-height;
  margin-top: $filter-groups-header-margin-top;
  margin-right: $filter-groups-header-margin-right;
  margin-bottom: $filter-groups-header-margin-bottom;
  margin-left: $filter-groups-header-margin-left;
}

.group {
  margin-top: $filter-groups-group-margin-top;
  margin-right: $filter-groups-group-margin-right;
  margin-bottom: $filter-groups-group-margin-bottom;
  margin-left: $filter-groups-group-margin-left;
}

.update-button {
  width: $filter-groups-button-update-width;
}

@media (max-width: $breakpoint-mobile) {
  .filter-groups {
    width: $mobile-filter-groups-width;
  }
}
